import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { GridForColumn } from "../../../../Constant";
import { COLUMN_DATA, GRID_COLUMN } from "../../../../Data/UiKit/Grid";

const GridColumnCart = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={GridForColumn} span={COLUMN_DATA} />
        <CardBody className="grid-showcase">
          <Row>
            <Col md="1" className="text-center"><span>col-md-1</span></Col>
            {GRID_COLUMN.map(({ size, item }, index) => (
              <Col md={size} className={`${item} text-center`} key={index}><span>{item}</span></Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default GridColumnCart;
